<template>
  <v-app>
    <MoleculesMyAppBar :admin-ui="false"/>
    <v-main>
      <slot/>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
</script>
